import { render, staticRenderFns } from "./PersonalInformationCollectionAndUse.vue?vue&type=template&id=47867598"
import script from "./PersonalInformationCollectionAndUse.vue?vue&type=script&lang=js"
export * from "./PersonalInformationCollectionAndUse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports